/* eslint-disable space-before-function-paren */
import axios from 'axios';
import sha256 from 'crypto-js/sha256';

// browser context logged server-side to explain failed or repeated enrollments
function buildClientInfo(diagnostics) {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    return {
        submitAttempt: diagnostics.submitAttempts,
        secondsSinceStart: diagnostics.startedAt ? Math.round((Date.now() - diagnostics.startedAt) / 1000) : null,
        stepHistory: diagnostics.stepHistory.slice(),
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        online: typeof navigator.onLine === "boolean" ? navigator.onLine : null,
        connectionType: connection && connection.effectiveType ? connection.effectiveType : null,
        language: navigator.language || null
    };
}

export default {
    loadAppData({commit, state}) {
        if (state.umbracoId) {
            return axios
                .all([
                    axios.get("/api/enrollment/countries"),
                    axios.get("/api/enrollment/getall"),
                    axios.get("/api/enrollment/profile"),
                    axios.get("/api/enrollment/get"),
                    axios.get("/api/gifts/gifts")
                ])
                .then(
                    axios.spread(function (country, consentTextObject, profile, devEnv, gifts) {
                        commit("SET_COUNTRIES", country.data);
                        commit("SET_CONSENT_TEXT_OBJECT", consentTextObject.data);
                        commit('SET_MEMBER', profile.data);
                        commit("SET_DEV_ENV", devEnv.data);
                        commit("SET_PRESENTS", gifts.data);
                        commit("SET_APP_LOADED", true);

                        // Init settings
                        var dkCountry = country.data.find(x => x.iso == "DK");
                        state.member.primaryAddress.countryObject = dkCountry;

                    })
                )
                .catch(error => {
                    console.log(error);
                    commit("SET_APP_LOADED", true);
                    commit("SET_ERROR", true);
                });
        } else {
            console.log("No umbraco id.");
            commit("SET_APP_LOADED", true);
            commit("SET_ERROR", true);
        }
    },
    loadEducationData({commit, state}) {
        return axios
            .all([
                axios.get("/api/enrollment/educations"),
                axios.get("/api/enrollment/educationplaces"),
            ])
            .then(
                axios.spread(function (edu, int) {
                    commit("SET_EDUCATIONS", edu.data);
                    commit("SET_INSTITUTES", int.data);

                    commit("SET_EDUCATION_LOADED", true);

                })
            )
            .catch(error => {
                console.log(error);
                commit("SET_ERROR", true);
                commit("SET_EDUCATION_LOADED", true);
                commit("SET_EDUCATION_ERROR", true);
            });
    },
    loadWorkData({commit, state}) {
        commit('SET_EMPLOYER_LOADING', true);
        return axios
            .all([
                axios.get("/api/enrollment/jobpositions"),
                axios.get("/api/enrollment/employments"),
                axios.get("/api/enrollment/workingareas"),
                axios.get("/api/enrollment/workplaces"),
                axios.get("/api/enrollment/dm_jobpositions")
            ])
            .then(
                axios.spread(function (job, employments, workingareas, workplaces, dm_jobpositions) {
                    commit('SET_JOBS', job.data);
                    commit('SET_JOB_TYPES', employments.data);
                    commit('SET_WORKING_AREAS', workingareas.data);
                    commit('SET_DM_JOB_POSITIONS', dm_jobpositions.data);

                    commit("SET_WORK_LOADED", true);
                    commit('SET_EMPLOYERS', workplaces.data);
                    commit('SET_EMPLOYER_LOADING', false);

                })
            )
            .catch(error => {
                console.log(error);
                commit("SET_ERROR", true);
                commit("SET_WORK_LOADED", true);
                commit("SET_WORK_ERROR", true);
                commit('SET_EMPLOYER_LOADING', false);
            });
    },
    loadMaData({commit, state}) {
        if (state.umbracoId != null) {
            return axios
                .all([
                    axios.get("/api/enrollment/countries?umbracoId=" + state.umbracoId),
                    axios.get("/api/enrollment/funds?umbracoId=" + state.umbracoId),
                ])
                .then(
                    axios.spread(function (maCountries, funds) {
                        commit('SET_MA_COUNTRIES', maCountries.data);
                        commit('SET_FUNDS', funds.data);


                        commit("SET_MA_LOADED", true);


                    })
                )
                .catch(error => {
                    console.log(error);
                    commit("SET_MA_LOADED", true);
                    commit("SET_MA_ERROR", true);
                });
        } else {
            console.log("No umbraco id.");
            commit("SET_ERROR", true);
            commit("SET_MA_LOADED", true);
            commit("SET_MA_ERROR", true);
        }
    },
    getChildUrl({
                    commit,
                    state
                }) {
        var recieptType = state.formType;

        if (state.subType != "student") {
            recieptType = state.subType;
        }

        if (state.isTrustee) {
            recieptType = "trustee";
        }

        if (state.isCallCenter) {
            recieptType = "callcenter";
        }

        // axios.get("/api/ma/get/url?formtype=" + recieptType + "&umbracoId=" + state.umbracoId).then(response => {
        //     commit('SET_CHILD_URL', response.data);
        // }).catch(error => {
        //     console.log(error);
        // });

        axios.get("/api/enrollment/url?recieptType=" + recieptType + "&umbracoId=" + state.umbracoId + "&campaignCode=" + state.campaignCode + "&english=" + state.english).then(response => { // /api/ma/get/url
            commit('SET_CHILD_URL', response.data);
        }).catch(error => {
            console.log(error);
        });
    },
    getCampaignConditions({
                              commit
                          }, campaignCode) {
        axios.get("/api/enrollment/condition?code=" + campaignCode).then(response => {
            commit('SET_CAMPAIGN_CONDITIONS', response.data);
        }).catch(error => {
            console.log(error);
        });
    },
    setEducationInstitute({commit}, payload) {
        commit('SET_EDUCATIONINSTITUTE', payload)
    },
    sendForm({
                 commit,
                 state,
                 dispatch
             }) {
        state.loadingResponse = true;

        // Basic setup for all
        state.member.statsGuid = state.enrollmentGuid;
        state.member.campaignCode = state.campaignCode;
        state.member.isTrustee = state.isTrustee;
        state.member.isCallCenter = state.isCallCenter;
        state.member.umbracoId = state.umbracoId;
        state.member.hostname = window.location.hostname;
        state.member.pageViewId = state.pageViewId;

        commit("INCREMENT_SUBMIT_ATTEMPTS");
        state.member.clientInfo = buildClientInfo(state.clientDiagnostics);

        state.member.cellularPhone = state.member.cellularPhone.replace(/\D/g, '');

        if (!state.isTrustee && !state.isCallCenter) {
            state.member.englishEnrollment = state.english;
        }

        if (state.formType !== "ma") {
            state.member.newsLetterConsent = true;
        }

        axios.post("/api/enrollment/create/profile", state.member, {
            headers: {
                'RequestVerificationToken': state.antiforgeryToken
            }
        }).then(response => {
            commit("SET_SERVER_RESPONSE", response.data);
            if (state.serverResponse.isSuccess) {
                if (state.childUrl) {
                    var urlParams = "&guid=" + state.enrollmentGuid;
                    urlParams += state.campaignCode ? "&campaign=" + state.campaignCode : "";

                    dispatch("gtmPageShow", true);
                    dispatch("gtmSubmitEvent");
                    dispatch("sendEventToEngage");
                    if (state.isCallCenter === false && state.isTrustee === false) {
                        state.adversusData.isCompleted = true;
                        dispatch('sendDataToAdversus');
                    }
                    window.location.href = state.childUrl + urlParams;
                } else {
                    commit("SET_SERVER_RESPONSE", {
                        isSuccess: false,
                        message: "Din indmeldelse er sendt afsted. Vi kunne ikke vise en kvittering. Kontakt DM."
                    });
                    dispatch("gtmError", [{
                        field: "ServerValidation",
                        msg: "Meldt ind, men kunne ikke vise kvitteringsside"
                    }]);
                    dispatch("gtmSubmitEvent");
                    state.loadingResponse = false;
                }
            } else {
                dispatch("gtmError", [{field: "ServerValidation", msg: state.serverResponse.message}]);
                state.loadingResponse = false;
            }
        }).catch(
            (error) => {
                console.log(error);
                commit("SET_SERVER_RESPONSE", {
                    isSuccess: false,
                    message: "Der skete en fejl, prøv igen senere."
                });
                dispatch("gtmError", [{field: "ServerError", msg: "Der skete en fejl, prøv igen senere."}]);
                state.loadingResponse = false;
            });
    },
    loadComponent({
                      commit,
                      state
                  }, payload) {
        const component = state.steps.find(comp => {
            return comp.name === payload;
        });

        commit("SET_CURRENT_COMPONENT", component);
    },
    initForm({commit, state, dispatch}) {
        if (state.subType && state.formType) {
            var correctSubType = state.selectChoices.map(x => x.value).includes(state.subType);
            var correctFormType = state.formType == "dm" || state.formType == "ma" || state.formType == "dmma";

            if (correctSubType && correctFormType) {
                // EXCEPTION UNTIL MA-FORM READY FOR ORDINARY MEMBERS
                if ((state.formType == "ma" || state.formType == "dmma") && state.subType != "student") {
                    console.log("Fejl - Kun studerende kan melde sig ind i MA via denne form");
                    commit("SET_MA_NOT_ALLOWED_WARNING", true);

                    setTimeout(() => {
                        commit("SET_MA_NOT_ALLOWED_WARNING", false);
                    }, 2000);
                } else {
                    commit("SET_NEWS_LETTER_TEXT");
                    dispatch("getChildUrl");

                    if (state.formType) {
                        commit("SET_STEPS");
                    }
                }

            } else {
                console.log("Fejl - forkert subtype eller formtype")
            }
        } else {
            console.log("No url parameters");
        }
    },
    isComponentValid({commit, state}, payload) {
        var componentFields = Object.keys(payload.fields[payload.formFields]);

        if (
            componentFields.some(
                key => payload.fields[payload.formFields][key].touched
            )
        ) {
            return !componentFields.some(
                key => payload.fields[payload.formFields][key].invalid
            );
        }

        return false;
    },
    gtmPageShow({commit, state}, isSubmit = false) {
        if (!state.currentComponent.isGtmShown || isSubmit) {
            var lang = state.english ? "en" : "da";
            var steps = state.fullFormFormat ? "1step" : "4step";

            var virtualPath = isSubmit ? "kvittering" : (state.fullFormFormat ? "fuld-format" : state.currentComponent.virtualPath);
            var virtualTitle = isSubmit ? "Godkendelse - submit ok - virtual page" : (state.fullFormFormat ? "Fuld format - visning" : state.currentComponent.text + " - visning");

            var path = "/virtual/" + lang + "/" + state.subType + "indmeld" + steps + "/" + state.formType + "/" + virtualPath;

            var emailLowerCase = state.member.email?.toLocaleLowerCase();
            var emailHashAsString = sha256(emailLowerCase).toString();

            // isSubmit ? console.log("GTM SUBMIT") : console.log("GTM SHOWN", state.currentComponent.name);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "track-vp",
                virtualPath: path,
                virtualTitle: virtualTitle,
                hashedEmail: emailHashAsString
            });

            if (!isSubmit) {
                commit("SET_GTM_SHOWN", state.currentComponent);
            }
        }

    },
    gtmError({state}, errors) {
        var steps = state.fullFormFormat ? "1step" : "4step";
        var errorString = "";

        if (errors.length > 0) {
            errors.forEach(function (val) {
                errorString += val.field + '-' + val.msg + '-' + (state.english ? "en" : "da") + ', ';
            });
        }

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push(
            {
                'event': 'track-event',
                'eventCategory': state.subType + 'indmeld-' + steps + ' ' + state.formType,
                'eventAction': state.fullFormFormat ? '01 - formular - error' : state.currentComponent.virtualPath + ' - error',
                'eventLabel': errorString,
                'eventValue': '0',
                'eventNoninteraction': true,
                'callcenter': state.isCallCenter ? "Ja" : "Nej",
                'hverver': state.isTrustee ? "Ja" : "Nej",
                'sprog': state.english ? "en" : "da",
                'subtype': state.subType
            });
    },
    gtmSubmitEvent({state}) {
        var steps = state.fullFormFormat ? "1step" : "4step";

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push(
            {
                'event': 'track-event',
                'eventCategory': state.subType + 'indmeld-' + steps + ' ' + state.formType,
                'eventAction': 'kvittering',
                'eventLabel': '',
                'eventValue': '0',
                'eventNoninteraction': true,
                'callcenter': state.isCallCenter ? "Ja" : "Nej",
                'hverver': state.isTrustee ? "Ja" : "Nej",
                'sprog': state.english ? "en" : "da",
                'subtype': state.subType,
                'newsLetter': state.member.newsLetterConsent ? "Ja" : "Nej",
                "lsbKontakt": state.member.lsbConsent ? "Ja" : "Nej",
                "abgKontakt": state.member.abgKontakt ? "Ja" : "Nej",
                "forsikring": state.member.insuranceInformationConsent ? "Ja" : "Nej"
            });
    },
    moveToNextStep({state, commit, dispatch}) {
        let currentIndex = state.steps.indexOf(state.currentComponent);
        if (currentIndex === 0) {
            dispatch('sendDataToAdversus');
        }
        commit('NEXT_COMPONENT');
    },
    sendDataToAdversus({state, commit, dispatch}) {
        if (state.adversusWebhookEnabled === true && state.isCallCenter === false && state.isTrustee === false) {
            state.adversusData.guid = state.enrollmentGuid;
            state.adversusData.campaign = state.campaignCode;
            state.adversusData.name = state.member.name;
            state.adversusData.phone = state.member.cellularPhone;
            state.adversusData.email = state.member.email;
            state.adversusData.hostname = window.location.hostname;
            state.adversusData.subtype = state.subType;

            axios.post("/api/enrollment/adversus", state.adversusData, {
                headers: {
                    'RequestVerificationToken': state.antiforgeryToken
                }
            });

        }
    },
    searchCompanyByCvr({state, commit}, cvr) {

        state.workFormState.loadingCompleted = false;
        state.workFormState.loadingCompanies = true;

        axios.get("/api/enrollment/workplaces/search", {
            params: {
                cvr: cvr
            }
        }).then(response => {
            if (response.data.hasResult) {
                state.workFormState.foundedCompany = response.data.company;
                state.workFormState.foundedCompanyWorkplaces = response.data.workplaces;
                state.workFormState.isPublicWorkplace = response.data.company.isPublic;
                state.workFormState.isAcWorkplace = response.data.company.isAcOrganization;
                state.workFormState.workplaceHasJobPositionStructure = response.data.company.hasJobPositionStructure;
            } else {
                state.workFormState.isPublicWorkplace = false;
                state.workFormState.isAcWorkplace = false;
                state.workFormState.workplaceSelected = true;
                state.member.unknownJobAccount = true;
            }
            state.workFormState.loadingCompleted = true;
            state.workFormState.loadingCompanies = false;
        });
    },
    sendEventToEngage({state}) {
        if (state.isCallCenter === false && state.isTrustee === false) {
            let isStudent = state.subType === "student";
            let label = isStudent ? "studerende" : "non-studerende";
            window.umbEngage("send", "event", "indmeldelse (overordnet type)", "indsendt", label);

            let url = new URL(state.childUrl, window.location.origin);
            let params = new URLSearchParams(url.search);
            let type = params.get('type');

            window.umbEngage("send", "event", "indmeldelse (specifik type)", "indsendt", type);
        }
    }
};